import { storeToRefs } from 'pinia';
import { useRegionsStore } from 'stores/regions-store';
import { useDataDictionary } from './useDataDictionary';

/**
 * Resolves a region from the client-side regions data dictionary by its `id`,
 * avoiding the need for the back end to embed a resolved region object in every
 * response. Returns the dictionary entry (`region_name`, `region_short_name`,
 * `region_type_id`, …) or `null` when the id is unknown.
 */
export function useRegionLookup() {
  const { dataDictionary } = storeToRefs(useRegionsStore());
  const { get: getRegion, byId } = useDataDictionary(dataDictionary);

  return { getRegion, regionsById: byId };
}
